import React from 'react';
import { Routes, Route } from 'react-router-dom';
import useAnalytics from '../../Hooks/useAnalytics.jsx';
import { Box, Snackbar, Alert } from '@mui/material';
import { useAuth } from '../../contexts/AuthContext/index.jsx';
import { ActiveComponentProvider } from '../ActiveComponentContext.js';
import AlertDialog from '../AlertDialog/index.jsx';
import LoginDialog from '../LoginDialog/index.jsx';
import MyAppBar from '../MyAppBar/index.jsx';
import Loading from '../Loading';
import useDelay from '../../Hooks/useDelay.js';
import Dashboard from '../../Pages/Dashboard/index.jsx';
import PostDetail from '../../Pages/PostDetail/index.jsx';
import MyPosts from '../../Pages/MyPosts/index.jsx';
import SavedPosts from '../../Pages/SavedPosts/index.jsx';
import UserProfiles from '../../Pages/UserProfiles/index.jsx';
import ProtectedRoute from '../ProtectedRoute/index.jsx';
import UserPostsPage from '../../Pages/UserPostsPage/index.jsx';
import AuthAction from '../../Pages/AuthAction/index.jsx';
import { routesConfig } from '../../Data/pageData.jsx';

//import CountrySelect from '../CountrySelect/index.jsx';

const App = () => {
  useAnalytics(); // This will log every route change
 
  const {
    loginOpen,
    openLogInModal,
    handleLoginClose,
    showAlertDialog,
    setShowAlertDialog,
    openDrawer,
    setOpenDrawer,
    verificationSnackbar,
    setVerificationSnackbar,
  } = useAuth(); // Use the AuthContext to get current user

  const isDelayed = useDelay(3000); // 3000ms delay
  if (isDelayed) {
    return <Loading />;
  }

  const handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') return;
    setVerificationSnackbar((prev) => ({ ...prev, open: false }));
  };
  

  return (
    <ActiveComponentProvider>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          width: '100vw',
          height: '100vh',
          overflowX: 'hidden',
          overflowY: 'auto',
          position: 'fixed', //keep top app bar fixed
        }}
      >
        <MyAppBar />
        {/* <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}> */}
        {/* <CountrySelect/>  */}
        <Routes>
          {routesConfig.map(({ path, element, categoryName }, index) =>
            path === '/' ? (
              <Route
                key={index}
                exact
                path={path}
                element={element}
                categoryName={categoryName}
              />
            ) : (
              <Route
                key={index}
                path={path}
                element={element}
                categoryName={categoryName}
              />
            )
          )}
          <Route path='/users' element={<UserProfiles />} />
          {/* <Route path='/:username' element={<UserPostsPage />} /> */}
          <Route path='/users/:userId' element={<UserPostsPage />} />

          <Route path='/posts/:id' element={<PostDetail />} />
          <Route
            path='/dashboard'
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          >
            <Route path='myposts' element={<MyPosts />} />
            <Route path='savedposts' element={<SavedPosts />} />
          </Route>
          <Route path='/auth/action' element={<AuthAction />} />
        </Routes>
        <Snackbar
          open={verificationSnackbar.open}
          autoHideDuration={6000}
          onClose={handleCloseSnackbar}
        >
          <Alert
            onClose={handleCloseSnackbar}
            severity={verificationSnackbar.severity}
            sx={{ width: '100%' }}
          >
            {verificationSnackbar.message}
          </Alert>
        </Snackbar>
        <AlertDialog
          open={showAlertDialog}
          handleCloseAlert={() => {
            setShowAlertDialog(false);
            if (openDrawer) {
              setOpenDrawer(false);
            }
          }}
          handleLogin={openLogInModal} // Pass the function to open login modal
        />
        <LoginDialog open={loginOpen} onClose={handleLoginClose} />
      </Box>
    </ActiveComponentProvider>
  );
};

export default App;
